import { keepPreviousData, useQuery } from '@tanstack/react-query';

export type Experience = {
  experienceid: string;
  experiencetitle: string;
  experiencedesc: string;
};

const getExperiences = async (
  searchQuery?: string,
  page?: number,
  limit?: number,
): Promise<{ experiences: Experience[]; totalPages: number }> => {
  const params = new URLSearchParams();
  if (searchQuery) params.set('q', searchQuery);
  if (limit !== undefined) params.set('limit', String(limit));
  if (page !== undefined) params.set('page', String(page));
  const response = await fetch(`/api/experiences?${params}`);
  return response.json();
};

export const EXPERIENCES_QUERY_KEY = 'experiences';

export const useExperiences = ({
  searchQuery,
  page,
  limit = 5,
}: {
  searchQuery?: string;
  page?: number;
  limit?: number;
}) =>
  useQuery({
    queryKey: [EXPERIENCES_QUERY_KEY, searchQuery, page, limit],
    queryFn: () => getExperiences(searchQuery, page, limit),
    placeholderData: keepPreviousData,
  });
